import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import cn from 'classnames';
import { useDeferredValue, useMemo, useRef } from 'react';
import { PlusSVG } from '@sbercloud/uikit-product-icons';
import { LAYOUT_TYPE } from '@sbercloud/uikit-product-utils';
import { ButtonFilled } from '@snack-uikit/button';
import { Scroll } from '@snack-uikit/scroll';
import { Tag } from '@snack-uikit/tag';
import { TruncateString } from '@snack-uikit/truncate-string';
import { Typography } from '@snack-uikit/typography';
import { PLATFORM } from '../../constants';
import { useCalculatorContext } from '../../contexts';
import { useProductClick, useProductDelete } from '../../hooks';
import { formatNumber, getPrice, parseKeyToDataTest } from '../../utils';
import { PricePeriodSelect, ProductCard, ProductListActions } from './components';
import { useScrollListToActiveProduct } from './hooks';
import styles from "./styles.module.css";
import { getTotalPrice, transformValueToProductCardData } from './utils';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var SummaryAppearance = /*#__PURE__*/function (SummaryAppearance) {
  SummaryAppearance["Welcome"] = "welcome";
  SummaryAppearance["Default"] = "default";
  return SummaryAppearance;
}({});
var PlatformSale = _defineProperty(_defineProperty(_defineProperty({}, PLATFORM.Evolution, 25), PLATFORM.Advanced, 25), PLATFORM.VmWare, 20);
export function PriceSummary(_ref) {
  var className = _ref.className,
    _ref$appearance = _ref.appearance,
    appearance = _ref$appearance === void 0 ? SummaryAppearance.Default : _ref$appearance;
  var _useCalculatorContext = useCalculatorContext(),
    layoutType = _useCalculatorContext.layoutType,
    pricePeriod = _useCalculatorContext.pricePeriod,
    setCatalogOpen = _useCalculatorContext.setCatalogOpen,
    calculatorType = _useCalculatorContext.calculatorType,
    selectedProduct = _useCalculatorContext.selectedProduct,
    products = _useCalculatorContext.products,
    _useCalculatorContext2 = _useCalculatorContext.config,
    productsProp = _useCalculatorContext2.products,
    platforms = _useCalculatorContext2.platforms,
    _useCalculatorContext3 = _useCalculatorContext.actions,
    onCatalogOpen = _useCalculatorContext3.onCatalogOpen,
    onStartClick = _useCalculatorContext3.onStartClick;
  var isMobile = layoutType !== LAYOUT_TYPE.Desktop && layoutType !== LAYOUT_TYPE.DesktopSmall;
  var isPartners = calculatorType === 'partners';
  var TitleComponent = isMobile ? Typography.SansTitleL : Typography.SansHeadlineS;
  var total = getPrice({
    price: getTotalPrice(products),
    pricePeriod: pricePeriod,
    partners: isPartners
  });
  var productCards = useMemo(function () {
    return transformValueToProductCardData(productsProp, products);
  }, [products, productsProp]);
  var hasPayaGo = useMemo(function () {
    var payaProducts = Object.values(productsProp).filter(function (product) {
      return product.hasPayaGo;
    });
    return Object.keys(products).some(function (productId) {
      return payaProducts.find(function (product) {
        return product.id === productId;
      });
    });
  }, [products, productsProp]);
  var scrollRef = useRef(null);
  var activeRef = useRef(null);
  useScrollListToActiveProduct({
    scrollRef: scrollRef,
    activeRef: activeRef
  });
  var handleProductDelete = useProductDelete();
  var handleProductClick = useProductClick();
  var deferredTotal = useDeferredValue(total);
  var handleCatalogOpen = function handleCatalogOpen() {
    onCatalogOpen === null || onCatalogOpen === void 0 ? void 0 : onCatalogOpen();
    setCatalogOpen(true);
  };
  var handleStartCatalog = function handleStartCatalog() {
    onStartClick === null || onStartClick === void 0 ? void 0 : onStartClick();
    setCatalogOpen(true);
  };
  var serviceButtonProps = {
    size: 'm',
    icon: /*#__PURE__*/_jsx(PlusSVG, {}),
    label: 'Добавить сервис',
    'data-test-id': parseKeyToDataTest('price', 'summary-button')
  };
  return /*#__PURE__*/_jsxs("div", {
    className: cn(styles.priceSummary, className),
    "data-mobile": isMobile || undefined,
    "data-test-id": parseKeyToDataTest('price', 'summary'),
    children: [/*#__PURE__*/_jsxs("div", {
      className: styles.headline,
      children: [/*#__PURE__*/_jsx(TitleComponent, {
        "data-test-id": parseKeyToDataTest('price', 'summary-title'),
        children: "\u0420\u0430\u0441\u0447\u0435\u0442"
      }), appearance === SummaryAppearance.Welcome && /*#__PURE__*/_jsx(ButtonFilled, _objectSpread({
        appearance: "primary",
        onClick: handleStartCatalog
      }, serviceButtonProps)), appearance === SummaryAppearance.Default && /*#__PURE__*/_jsx(ButtonFilled, _objectSpread({
        appearance: "primary",
        fullWidth: isMobile,
        onClick: handleCatalogOpen
      }, serviceButtonProps))]
    }), /*#__PURE__*/_jsx(Scroll, {
      className: styles.scroll,
      ref: scrollRef,
      "data-test-id": parseKeyToDataTest('price', 'summary-products'),
      children: /*#__PURE__*/_jsx("div", {
        className: styles.content,
        children: Object.entries(productCards).filter(function (_ref2) {
          var _ref3 = _slicedToArray(_ref2, 2),
            products = _ref3[1];
          return products.length > 0;
        }).map(function (_ref4) {
          var _platforms$find;
          var _ref5 = _slicedToArray(_ref4, 2),
            platformId = _ref5[0],
            cards = _ref5[1];
          return /*#__PURE__*/_jsxs("div", {
            className: styles.platform,
            children: [/*#__PURE__*/_jsxs(Typography.SansTitleM, {
              "data-test-id": parseKeyToDataTest('price', 'summary-platform'),
              children: ["\u041F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u0430 ", (_platforms$find = platforms.find(function (item) {
                return item.id === platformId;
              })) === null || _platforms$find === void 0 ? void 0 : _platforms$find.label, ' ', isPartners && /*#__PURE__*/_jsx(Tag, {
                label: "".concat(PlatformSale[platformId], "% \u0441\u043A\u0438\u0434\u043A\u0430"),
                appearance: "red",
                size: "xs"
              })]
            }), /*#__PURE__*/_jsx("div", {
              className: styles.body,
              children: cards.map(function (_ref6) {
                var id = _ref6.id,
                  idx = _ref6.idx,
                  label = _ref6.label;
                return /*#__PURE__*/_jsx("div", {
                  ref: (selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.id) === id && (selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.idx) === idx ? activeRef : undefined,
                  children: /*#__PURE__*/_jsx(ProductCard, {
                    id: id,
                    idx: idx,
                    label: label,
                    selectedProduct: selectedProduct,
                    onProductClick: handleProductClick,
                    onProductDelete: handleProductDelete
                  })
                }, id + idx);
              })
            })]
          }, platformId);
        })
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.footer,
      "data-test-id": parseKeyToDataTest('price', 'summary-footer'),
      children: [/*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx("div", {
          className: styles.caption,
          "data-test-id": parseKeyToDataTest('price', 'summary-title'),
          children: "\u041E\u0431\u0449\u0430\u044F \u0441\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u044C \u0441\xA0\u041D\u0414\u0421"
        }), /*#__PURE__*/_jsxs("div", {
          className: styles.footerHeadline,
          children: [/*#__PURE__*/_jsxs("div", {
            className: styles.total,
            "data-test-id": parseKeyToDataTest('price', 'summary-footer-total'),
            children: [/*#__PURE__*/_jsx(Typography.SansHeadlineS, {
              children: /*#__PURE__*/_jsx(TruncateString, {
                text: formatNumber(deferredTotal),
                maxLines: 1
              })
            }), /*#__PURE__*/_jsx(Typography.SansTitleL, {
              children: "\u20BD"
            })]
          }), /*#__PURE__*/_jsx(PricePeriodSelect, {
            hasPayaGo: hasPayaGo
          })]
        })]
      }), /*#__PURE__*/_jsx(ProductListActions, {
        disabled: appearance === SummaryAppearance.Welcome
      })]
    })]
  });
}